import { ContainerPadding, CTA, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useCallback, useEffect, useState } from 'react';
import { CloseLayerCTA } from '../../components/cta/close-layer-cta';
import { ConsentimientosEnvioSection } from '../../components/inputs-group/consentimientos-envio-section';
import { DatosPersonalesInputsGroup } from '../../components/inputs-group/datos-personales-inputs-group';
import { DealersRadio } from '../../components/inputs-group/inputs/dealers-radio';
import { OfertaHeaderSection } from '../../components/inputs-group/inputs/vehicle-section/oferta-header-section';
import { VehicleSection } from '../../components/inputs-group/inputs/vehicle-section/vehicle-section';
import { LegalesSection } from '../../components/inputs-group/legales-section';
import { LoadingScreen } from '../../components/screen/loading';
import { Section } from '../../components/screen/section';
import { ThankyouScreen } from '../../components/screen/thankyou';
import { useApp } from '../../contexts/app-context';
import { ndpsEntity } from '../../entities/ndps-entity';
import { personEntity } from '../../entities/person-entity';
import { vehicleEntity } from '../../entities/vehicle-entity';
import { isComerciales } from '../../helpers/carline-helpers';
import { setProductData } from '../../service/product-data';

export const LeadVentaOfertaForm = () => {
	const { setAppThankyouScreen } = useApp();
	const [ofertaLoading, setOfertaLoading] = useState(true);
	const [oferta, setOferta] = useState(false);

	const getFormData = useCallback(() => {
		const ndpsToken = isComerciales() ? 'LCV_DDB_FRM_LEM_REC_LEM' : 'VW_DDB_FRM_LEM_REC_LEM';
		ndpsEntity.setToken(ndpsToken);

		return {
			'headers[FK_SYSTEM]': ndpsToken,
			'headers[DPS_TOKEN]': ndpsToken,

			'flags[PERSON_RGPD_ADAPTED]': true,
			'flags[FLAG_IS_MYSTERY_LEAD]': false,
			'flags[FLAG_RELACION_MARCA_SIN_IC]': false,
			'flags[FLAG_SF_INTEGRATION]': true,
			'flags[FLAG_IS_COMPANY]': isComerciales() ? false : undefined,
			'flags[FLAG_ALLOWS_DATA_ENRICHMENT]': isComerciales() ? undefined : false,

			'fields[PERSON_TREATMENT]': isComerciales() ? personEntity.treatment : undefined,
			'fields[PERSON_NAME]': personEntity.name,
			'fields[PERSON_SURNAME_1]': personEntity.surname,
			'fields[PERSON_SURNAME_2]': personEntity.secondSurname,
			'fields[PERSON_EMAIL]': personEntity.email,
			'fields[PERSON_PHONE_PREFIX]': personEntity.phonePrefix,
			'fields[PERSON_PHONE_MOBILE]': personEntity.phone,
			'fields[PERSON_PHONE_MOBILE_FULL]': personEntity.phonePrefix + personEntity.phone,
			'fields[PERSON_POSTAL_CP]': personEntity.postalCode,

			// PRODUCT DATA (cada data sobreescribe valores del anterior)
			...ndpsEntity.dealerData,
			...ndpsEntity.vehicleData,
		};
	}, []);

	const Form = () => (
		<>
			{ofertaLoading ? (
				<LoadingScreen />
			) : oferta ? (
				<OfertaHeaderSection paddingBottom={ContainerPadding.static515} />
			) : (
				<VehicleSection paddingBottom={ContainerPadding.static515} />
			)}
			<Section paddingBottom={ContainerPadding.static515}>
				<Text bold appearance={TokenTextAppearance.headline200}>
					¿Cómo nos ponemos en contacto contigo?
				</Text>
				<Text appearance={TokenTextAppearance.copy200}>
					El responsable de los datos de contacto y preferencias que nos proporciones será Volkswagen Group España
					Distribución, S.A.U., que los compartirá con el concesionario que hayas seleccionado, con el fin de que este
					pueda dar respuesta a tu solicitud. El concesionario tratará tus datos personales como encargado del
					tratamiento.
				</Text>
				<DatosPersonalesInputsGroup />
			</Section>
			<Section paddingBottom={ContainerPadding.static515}>
				<Text bold appearance={TokenTextAppearance.headline200}>
					¿Qué instalación te queda más cerca?
				</Text>
				<Text appearance={TokenTextAppearance.copy200}>
					Haremos llegar tus datos al punto de venta para que puedan ayudarte.
				</Text>
				<DealersRadio />
			</Section>
			<ConsentimientosEnvioSection formData={getFormData} showComunicacionesComerciales />
			<LegalesSection />
		</>
	);

	const CustomThankyou = () => {
		const ctasThankyouScreen = [
			vehicleEntity.showroomUrl ? (
				<CTA tag="a" href={vehicleEntity.showroomUrl} emphasis="primary">
					Conócelo
				</CTA>
			) : null,
			<CloseLayerCTA label="Seguir navegando" />,
		];
		return (
			<ThankyouScreen
				title={
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
						{isComerciales() ? (
							'¡Muchas gracias por tu interés!'
						) : (
							<>
								Estás muy cerca de conducir un <Text bold>{vehicleEntity.carlineTitle || 'Volkswagen'}</Text>
							</>
						)}
					</Text>
				}
				text={
					<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
						{isComerciales()
							? 'En breve te llamaremos desde un número terminado en 904.'
							: 'Un asesor contactará contigo muy pronto para darte todos los detalles sobre esta oferta.'}
					</Text>
				}
				ctas={ctasThankyouScreen}
			/>
		);
	};

	useEffect(() => {
		//setAppLoading(true);
		setAppThankyouScreen(<CustomThankyou />);

		setProductData().then((oferta: unknown) => {
			//setAppLoading(false);
			setOfertaLoading(false);
			setOferta(Boolean(oferta));
		});
	}, []);

	return Form();
};
